export default "__VITE_ASSET__078c4f46__"